import React from "react";

import BaseSvg, { BaseSvgProps } from "../../BaseSvg";

const ConcentrationSvg: React.FunctionComponent<BaseSvgProps> = ({
  className = "",
  fillColor,
  secondaryFillColor,
}) => {
  return (
    <BaseSvg className={className} viewBox="0 0 19.73 21.49">
      <rect
        fill={fillColor}
        x="2.95"
        y="2.95"
        width="15"
        height="15"
        transform="translate(-4.18 10.09) rotate(-45)"
      />
      <path
        fill={secondaryFillColor}
        d="M12.53,10.92v0A2.44,2.44,0,0,1,12,12.71a2.19,2.19,0,0,1-1.67.6,2.35,2.35,0,0,1-1.76-.68,2.63,2.63,0,0,1-.66-1.92V8.59a2.7,2.7,0,0,1,.64-1.92A2.23,2.23,0,0,1,10.24,6,2.26,2.26,0,0,1,12,6.6a2.56,2.56,0,0,1,.6,1.79v0H11.2a1.66,1.66,0,0,0-.19-1,.88.88,0,0,0-.77-.31.82.82,0,0,0-.72.37,2,2,0,0,0-.25,1.11v2.14a1.91,1.91,0,0,0,.27,1.12.9.9,0,0,0,.78.37.79.79,0,0,0,.7-.29,1.73,1.73,0,0,0,.17-1Z"
      />
    </BaseSvg>
  );
};

export default ConcentrationSvg;
